import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  isAuthenticated: boolean;
  isLoading: boolean;
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ isAuthenticated, isLoading, children }) => {
  if (isLoading) {
    // 🔄 登录状态还在加载，什么也别跳
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    // ❌ 没登录才跳转
    return <Navigate to="/login" replace />;
  }

  // ✅ 已登录，正常显示
  return <>{children}</>;
};

export default ProtectedRoute;
